import axios from 'axios';

export type ModelProvider = 'qwen' | 'deepseek';
let currentProvider: ModelProvider = 'qwen';
let hasCredential = false;
let hasQwenCredential = false;
let qwenWorkspaceId = '';

export function modelCredentialStatus(): { provider: ModelProvider; active: boolean } {
  return { provider: currentProvider, active: hasCredential };
}

export function qwenCredentialStatus(): boolean {
  return hasQwenCredential || (currentProvider === 'qwen' && hasCredential);
}

export function setModelCredential(provider: ModelProvider, key: string): void {
  currentProvider = provider;
  hasCredential = Boolean(key.trim());
  if (key.trim()) {
    axios.defaults.headers.common['X-Morpho-Provider'] = provider;
    axios.defaults.headers.common['X-Morpho-Api-Key'] = key.trim();
  } else {
    delete axios.defaults.headers.common['X-Morpho-Provider'];
    delete axios.defaults.headers.common['X-Morpho-Api-Key'];
  }
}

export function setQwenCredential(key: string): void {
  hasQwenCredential = Boolean(key.trim());
  if (hasQwenCredential) {
    axios.defaults.headers.common['X-Morpho-Qwen-Api-Key'] = key.trim();
  } else {
    delete axios.defaults.headers.common['X-Morpho-Qwen-Api-Key'];
  }
}

export function setQwenWorkspaceId(value: string): void {
  qwenWorkspaceId = value.trim();
  if (qwenWorkspaceId) {
    axios.defaults.headers.common['X-Morpho-Qwen-Workspace-Id'] = qwenWorkspaceId;
  } else {
    delete axios.defaults.headers.common['X-Morpho-Qwen-Workspace-Id'];
  }
}
